<template>
    <div>
        <h2 class="section-subtitle">Přihlášky do týmu</h2>
        <v-row>
            <v-col cols="16" offset="0" md="10" offset-md="3" sm="14" offset-sm="1">
                <v-card flat>
                    <div class="table-responsive">
                        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

                        <v-data-table
                            v-else-if="!loading && requests.length > 0"
                            :headers="header"
                            :items="requests"
                            must-sort
                            hide-default-footer
                            light
                            class="transparent"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="v-data-table__mobile-row">
                                        <router-link :to="{ name: 'userDetail', params: { id: props.item.user.id } }">
                                            <img
                                                src="/img/myteam/Avatar.png"><span>{{ props.item.user.nickname }}</span>
                                        </router-link>
                                    </td>
                                    <td class="v-data-table__mobile-row">
                                        {{ props.item.created.date | formatToday }}
                                    </td>
                                    <td class="v-data-table__mobile-row">
                                        <team-request-control :request-id="props.item.id"></team-request-control>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>

                        <p v-else-if="!loading && requests.length === 0">
                            Nejsou žádné přihlášky do vašeho týmu.
                        </p>
                    </div>
                </v-card>
            </v-col>
        </v-row>

    </div>
</template>

<script>
    import { captureException as SentryCaptureException } from '@sentry/browser'
    import { LOAD_TEAM_REQUESTS_REQUEST } from '../../store/actions/team'
    import TeamRequestControl from './TeamRequestControl';

    export default {
        name: 'TeamRequests',
        components: {
            TeamRequestControl,
        },
        data () {
            return {
                header: [
                    {
                        text: 'Hráč',
                        value: 'name',
                    },
                    {
                        text: 'Vytvořeno',
                        value: 'created',
                    },
                    {
                        text: 'Akce',
                        value: 'id',
                        sortable: false,
                        align: 'left',
                    },
                ],
                loading: false,
                requests: [],
            }
        },
        async mounted () {
            try {
                this.loading = true;
                this.requests = await this.$store.dispatch('team/' + LOAD_TEAM_REQUESTS_REQUEST);
            } catch (e) {
                this.$toast.error('Došlo k chybě při načítání žádostí. Zkuste to později.');
                SentryCaptureException(e);
            } finally {
                this.loading = false;
            }
        },
    }
</script>
